import { createElement, useState } from 'react';
import { useHistory } from 'react-router';
import { Card, Page, Spinner, TextButton, Typography } from 'seagull';
import ExternalLinkButton from "../../../components/ExternalLinkButton";
import { routes } from "../../../constants";
import { useIoContext, useStore } from "../../../contexts";
import { useOnMount } from "../../../hooks/useOnMount";
import { selectors } from "../../../store/state-selectors";
import { helpArticles } from "../../../utils/helpArticles";
import { loadZapierJsAndCss } from "../../../utils/zapier-elements";
import styles from "./HubspotViaZapierPage.module.scss";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var LoadZapierStatus = /*#__PURE__*/function (LoadZapierStatus) {
  LoadZapierStatus["Loading"] = "loading";
  LoadZapierStatus["Success"] = "success";
  LoadZapierStatus["Error"] = "error";
  return LoadZapierStatus;
}(LoadZapierStatus || {});
const uiMap = {
  [LoadZapierStatus.Success]: function SuccessState() {
    const userEmail = useStore(selectors.user.email);
    const userFirstName = useStore(selectors.user.firstName);
    const userLastName = useStore(selectors.user.lastName);
    return /*#__PURE__*/_jsx(Card, {
      autoHeight: true,
      padding: "m",
      children: /*#__PURE__*/_jsx("zapier-zap-templates", {
        "data-testid": "zapier-zap-templates",
        "sign-up-email": userEmail,
        "sign-up-first-name": userFirstName,
        "sign-up-last-name": userLastName,
        "client-id": "ieG0DJXKRhT4gI3t1DfefyH3YmooofjSMrEecI1t",
        theme: "light",
        ids: "1716073,1716052,1716071,1716065,1716069,1716061,1716058,1716067",
        limit: 5,
        "use-this-zap": "show"
      })
    });
  },
  [LoadZapierStatus.Loading]: function LoadingState() {
    return /*#__PURE__*/_jsx("div", {
      className: styles.centeredBox,
      "data-testid": "zapier-loading",
      children: /*#__PURE__*/_jsx(Spinner, {})
    });
  },
  [LoadZapierStatus.Error]: function ErrorState() {
    const {
      locationReload
    } = useIoContext();
    return /*#__PURE__*/_jsx("div", {
      className: styles.centeredBox,
      "data-testid": "zapier-error",
      children: /*#__PURE__*/_jsxs(Typography, {
        children: ["An error occurred. ", /*#__PURE__*/_jsx(TextButton, {
          onClick: () => locationReload(),
          children: "Reload"
        }), " to try again."]
      })
    });
  }
};
export default function HubspotViaZapierPage() {
  const {
    injectScriptOrLink
  } = useIoContext();
  const history = useHistory();
  const [loadZapierStatus, setLoadZapierStatus] = useState(null);
  useOnMount(() => {
    setLoadZapierStatus(LoadZapierStatus.Loading);
    loadZapierJsAndCss({
      injectScriptOrLink
    }).then(() => setLoadZapierStatus(LoadZapierStatus.Success)).catch(() => setLoadZapierStatus(LoadZapierStatus.Error));
  });
  return /*#__PURE__*/_jsx(Page, {
    testId: "hubspot-via-zapier",
    header: "Recommended HubSpot Zaps",
    subheader: /*#__PURE__*/_jsxs(_Fragment, {
      children: ["Automate workflows with Anchor and HubSpot using Zapier's templates. ", /*#__PURE__*/_jsx(ExternalLinkButton, {
        openInNewTab: true,
        underline: "none",
        href: helpArticles.anchorZaps(),
        children: "Learn more"
      })]
    }),
    onClickBack: () => history.push(routes.availableApps),
    children: loadZapierStatus && /*#__PURE__*/createElement(uiMap[loadZapierStatus])
  });
}